import { render, staticRenderFns } from "./Agt-saft.vue?vue&type=template&id=2e8cdada&"
import script from "./Agt-saft.vue?vue&type=script&lang=js&"
export * from "./Agt-saft.vue?vue&type=script&lang=js&"
import style0 from "./Agt-saft.vue?vue&type=style&index=0&id=2e8cdada&prod&scoped%5C=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports